import * as HttpService from './http.service';
import * as URL from './url.service';

export const createDemand = (projectId, data) => HttpService.postWithAuth(URL.CREATE_DEMAND_URL(projectId), data);

export const getProjectDemands = async (projectId, offset, limit, search, employeeMode, wbsL4Code, isGradeIncluded = false, args = { alSACode: '', alSSACode: '', alSSFCode: '' }) => HttpService.getWithAuth(
    URL.GET_PROJECT_DEMANDS(projectId, offset, limit, search, employeeMode, wbsL4Code, isGradeIncluded, args.alSACode, args.alSSACode, args.alSSFCode)
);

export const getPaginatedProjectDemands = async ({ projectId, offset, limit, filterType, search, filter, sort, isFav, statusType }) => HttpService.getWithAuth(
    URL.GET_PAGINATED_PROJECT_DEMANDS({ projectId, offset, limit, search, filter, filterType, sort, isFav, statusType })
);

export const getPaginatedDemandsForProjectDetails = async ({ projectId, offset, limit, filterType, search, filter, sort, isFav, statusType }) => HttpService.getWithAuth(
    URL.GET_PAGINATED_DEMANDS_FOR_PROJECT_DETAILS({ projectId, offset, limit, search, filter, filterType, sort, isFav, statusType })
);

export const getDemandDetails = (id) => HttpService.getWithAuth(URL.GET_DEMAND_DETAILS_URL(id));
export const getDemandDetailsForRequisition = (id, locations) => HttpService.getWithAuth(URL.GET_DEMAND_DETAILS_FOR_REQUISITION_URL(id, locations));

export const updateDemandDetails = (id, data) => HttpService.putWithAuth(URL.UPDATE_DEMAND_URL(id), data);

export const updateDemand = ({ demandId, projectId }, body) => HttpService.putWithAuth(URL.UPDATE_DEMAND_DETAIL_URL({ demandId, projectId }), body);

export const getAllDemands = (offset, limit, filters, sorts, search, isFavList, showInactive) => HttpService.getWithAuth(URL.GET_ALL_DEMANDS_URL(offset, limit, filters, sorts, search, isFavList, showInactive));

export const getRejected = (demandId, offset, limit) => HttpService.getWithAuth(URL.GET_REJECTED_RESOURCES(demandId, offset, limit));

export const deleteDemand = (demandId, deleteDemandFlag, startDate, endDate) => HttpService.deleteWithAuth(URL.DELETE_DEMAND_URL(demandId, deleteDemandFlag, startDate, endDate));
export const toggleDemandStatus = (demandId, toggleDemandFlag, startDate, endDate, inactiveReason, excludeRequisition) => HttpService.putWithAuth(URL.TOGGLE_DEMAND_STATUS_URL(demandId), { inactiveReason, startDate, endDate, toggleDemandFlag, excludeRequisition });
export const bulkToggleDemandStatus = ({
    projectId,
    currDemandStatus,
    isSelectAll,
    demands,
    demandStatus,
    isOnlyValidation,
    comment,
    excludeRequisition
}) => HttpService.putWithAuth(URL.BULK_TOGGLE_DEMAND_STATUS_URL({
    projectId,
    currDemandStatus,
    isSelectAll,
    demands,
    demandStatus,
    isOnlyValidation,
    comment,
    excludeRequisition
}), {});

export const updateTimeline = (data) => HttpService.putWithAuth(URL.UPDATE_TIMELINE_URL, data)

export const getDemandsCsv = ({ filter, sort, search, byId, idList, type, showInactive }) => HttpService.getWithAuth(URL.GET_DEMANDS_CSV_URL(filter, sort, search, byId, idList, type, showInactive));

export const getShiftTimings = ({ offset, limit, search }) => HttpService.getWithAuth(URL.GET_SHIFT_TIMINGS_URL({ offset, limit, search }));

export const getDemandShiftTimingsByDemandId = ({ demandId }) => HttpService.getWithAuth(URL.GET_DEMAND_SHIFT_TIMINGS_BY_DEMAND_ID({ demandId }));

export const getDemandPrefillData = ({ demandId }) => HttpService.getWithAuth(URL.GET_DEMAND_PREFILL_DATA({ demandId })); 

export const getBulkUploadDemandsTemplate = ({ type = 'demands' } = {}) => HttpService.getWithAuth(URL.GET_BULK_UPLOAD_DEMANDS_TEMPLATE_URL({ type }));